module.exports = __webpack_public_path__ + "static/media/10n.85b0244d.svg";